import { useSite } from "@/context/SiteContext";
import { SmartLink } from "@/components/common";
import { mediaUrl } from "@/lib/api";

export default function Footer() {
  const { settings } = useSite();
  const f = settings.footer;
  return (
    <footer className="relative mt-24 print:hidden overflow-hidden bg-bt-primary text-bt-bg" data-testid="site-footer">
      <svg className="absolute -right-24 -top-24 h-72 w-[36rem] opacity-10" viewBox="0 0 200 100" fill="none">
        <path d="M100 50c-18-26-38-38-58-38C20 12 6 30 6 50s14 38 36 38c20 0 40-12 58-38zm0 0c18 26 38 38 58 38 22 0 36-18 36-38s-14-38-36-38c-20 0-40 12-58 38z" stroke="currentColor" strokeWidth="3" />
      </svg>
      <div className="container-bt relative grid gap-12 py-16 md:grid-cols-[1.4fr_1fr_1fr]">
        <div>
          <div className="mb-5 flex items-center gap-3">
            <div className="rounded-2xl bg-bt-bg p-2"><img src={mediaUrl(settings.brand.logo_url)} alt="" className="h-8 w-auto" /></div>
            <span className="font-heading text-2xl" style={{ color: "var(--bt-background)" }}>{settings.brand.site_name}</span>
          </div>
          <p className="max-w-md text-base leading-relaxed opacity-85" data-testid="footer-mission">{f.mission}</p>
        </div>
        <div>
          <p className="mb-4 text-xs font-semibold uppercase tracking-[0.2em] opacity-60">Explore</p>
          <ul className="space-y-3">
            {f.links.map((l) => (
              <li key={l.label}><SmartLink to={l.url} className="opacity-90 transition-opacity hover:opacity-100 hover:underline" data-testid={`footer-link-${l.label.toLowerCase().replace(/\W+/g, "-")}`}>{l.label}</SmartLink></li>
            ))}
          </ul>
        </div>
        <div>
          <p className="mb-4 text-xs font-semibold uppercase tracking-[0.2em] opacity-60">Follow</p>
          <ul className="space-y-3">
            {f.social.map((l) => (
              <li key={l.label}><SmartLink to={l.url} className="opacity-90 hover:underline" data-testid={`footer-social-${l.label.toLowerCase()}`}>{l.label}</SmartLink></li>
            ))}
          </ul>
        </div>
      </div>
      <div className="container-bt relative border-t border-white/15 py-8 text-sm opacity-75">
        <p className="mb-3 max-w-3xl" data-testid="footer-disclaimer">{f.disclaimer}</p>
        <p>{f.copyright} {new Date().getFullYear()}</p>
      </div>
    </footer>
  );
}
